import { render, staticRenderFns } from "./EditUnitWorkModal.vue?vue&type=template&id=da230060"
import script from "./EditUnitWorkModal.vue?vue&type=script&lang=js"
export * from "./EditUnitWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports